import Vue from 'vue';

import { th } from '@/helper/locale/th_1054';
import { en } from '@/helper/locale/en_1033';

export default {

    // install(Vue) {
    //     var KEY_COOKIE_LOCALE = 'BzbsLocale';

    //     Vue.locale = {

    //     };
    // }
    KEY_COOKIE_LOCALE: 'BzbsLocale',
    defaultLocale: {
        code: 1054,
        short: 'th',
    },
    getLocale: function() {
        var locale = Vue.$cookies.get(this.KEY_COOKIE_LOCALE);
        if (locale == null) {
            locale = this.defaultLocale;
        }
        return locale;
    },
    getLocaleCode: function() {
        var localeObj = this.getLocale();
        return localeObj.code;
    },
    getLbl: function() {
        if (this.getLocaleCode() == 1033) {
            return en;
        } else {
            return th;
        }
    },
    getLocaleShort: function() {
        var localeObj = this.getLocale();
        return localeObj.short;
    },
    setLocale: function(localeCode) {
        var localeObj = {
            code: 1054,
            short: 'th',
        };
        if (localeCode == 1033) {
            localeObj = {
                code: 1033,
                short: 'en',
            };
        }
        let strLocale = JSON.stringify(localeObj);
        Vue.$cookies.set(this.KEY_COOKIE_LOCALE, strLocale);
    },
}
